import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "../apiConfig";

const useGetCampaignById = (id) => {
  const [campaignData, setCampaignData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${baseUrl}/campaign-details-for-influencers/${id}`
      );
      setCampaignData(res?.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  return [campaignData, isLoading];
};

export default useGetCampaignById;
